import React from "react";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TableImage from "../../shared/TableCard/TableImage";

export default function ProgramTable({ heading, allPrograms, loading, history, search, setSearch, onDelete }) {
    const actions = (d) => {
        return (
            <div className="flex justify-content-around">
                <i className="pi pi-eye cursor-pointer" onClick={() => history.push(`/program/view/${d._id}`)}></i>
                <i className="pi pi-pencil cursor-pointer" onClick={() => history.push(`/program/edit/${d._id}`)}></i>
                <i className="pi pi-trash cursor-pointer" onClick={() => onDelete(d._id)}></i>
            </div>
        );
    };

    const image = (r) => {
        const image = r.coverImage;
        return <TableImage image={image} />;
    };

    return (
        <TableCard
            title={heading}
            onSearch={setSearch}
            searchKeyword={search}
            buttonTitle="Add Program"
            linkTo={`/program/add/`}
            extraButtons={[{ buttonTitle: "Sort", linkTo: `/program/reorder/` }]}
        >
            <DataTable paginator value={allPrograms} showGridlines rows={10} loading={loading} emptyMessage="No Program found.">
                <Column field="name" header="Name" style={{ width: "250px" }}></Column>
                <Column body={image} header="Image" style={{ width: "80px" }}></Column>
                <Column field="description" header="Description" style={{ width: "250px" }}></Column>
                <Column body={actions} style={{ width: "80px" }} header="Action"></Column>
            </DataTable>
        </TableCard>
    );
}
